import { useEffect, useState } from 'react';

const CITIES = [
  { label: 'NEW YORK', tz: 'America/New_York' },
  { label: 'LONDON', tz: 'Europe/London' },
  { label: 'YEREVAN', tz: 'Asia/Yerevan' },
  { label: 'TOKYO', tz: 'Asia/Tokyo' },
];

function timeIn(tz: string, d: Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: tz,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(d);
}

export function WorldClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="world-clock">
      {CITIES.map((c) => (
        <div className="wc-city" key={c.label}>
          <div className="wc-label">{c.label}</div>
          <div className="wc-time">{timeIn(c.tz, now)}</div>
        </div>
      ))}
    </div>
  );
}
